// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"103":"donations","443":"about","535":"login"}[chunkId] || chunkId) + "-legacy." + {"103":"8e093a8b","419":"46713d73","443":"2a1b3847","535":"c5b489b5"}[chunkId] + ".js";
};